import { lazy } from "react";
import { createBrowserRouter } from "react-router-dom";
import { AppShell } from "@/components/layout/AppShell";
import ProtectedRoute from "@/features/auth/ProtectedRoute";
import RouteErrorBoundary from "@/components/errors/RouteErrorBoundary";

const LoginPage = lazy(() => import("@/features/auth/LoginPage"));
const UnauthorizedPage = lazy(() => import("@/features/auth/UnauthorizedPage"));
const NotFoundPage = lazy(() => import("@/features/NotFoundPage"));

const DashboardLayout = lazy(() => import("@/features/exec-ops/DashboardLayout"));
const OverviewPage = lazy(() => import("@/features/exec-ops/overview"));
const ScorecardsPage = lazy(() => import("@/features/exec-ops/scorecards"));
const ExceptionsPage = lazy(() => import("@/features/exec-ops/exceptions"));
const AccountabilityPage = lazy(() => import("@/features/exec-ops/accountability"));
const WeeklySummaryPage = lazy(() => import("@/features/exec-ops/weekly-summary"));
const DelegationPage = lazy(() => import("@/features/exec-ops/delegation"));
const AdminPage = lazy(() => import("@/features/exec-ops/admin"));

export const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  { path: "/unauthorized", element: <UnauthorizedPage /> },
  {
    element: <ProtectedRoute />,
    errorElement: <RouteErrorBoundary />,
    children: [
      {
        element: <AppShell />,
        children: [
          {
            element: <DashboardLayout />,
            children: [
              { index: true, element: <OverviewPage /> },
              { path: "scorecards", element: <ScorecardsPage /> },
              { path: "exceptions", element: <ExceptionsPage /> },
              { path: "accountability", element: <AccountabilityPage /> },
              { path: "weekly-summary", element: <WeeklySummaryPage /> },
              { path: "delegation", element: <DelegationPage /> },
              { path: "admin", element: <AdminPage /> },
            ],
          },
          { path: "*", element: <NotFoundPage /> },
        ],
      },
    ],
  },
]);
